export const isIdleInsight = (insight) =>
  Array.isArray(insight?.insightTriggers) &&
  insight.insightTriggers.some((trigger) => Number(trigger?.insightTriggerType) === 5);

// Idle narration shares guide membership without becoming a previous lesson step.
export const getPreviousOrdinaryInsight = (insights, index) => {
  for (let previous = index - 1; previous >= 0; previous -= 1) {
    if (insights[previous] && !isIdleInsight(insights[previous])) {
      return insights[previous];
    }
  }
  return null;
};

// Stable partition preserves author-selected ordering within both sections.
export const orderGuideInsights = (insights = []) => [
  ...insights.filter((insight) => !isIdleInsight(insight)),
  ...insights.filter(isIdleInsight),
];
